import { render, staticRenderFns } from "./WarrantyConfigList.vue?vue&type=template&id=ba7f0628&scoped=true&"
import script from "./WarrantyConfigList.vue?vue&type=script&lang=js&"
export * from "./WarrantyConfigList.vue?vue&type=script&lang=js&"
import style0 from "./WarrantyConfigList.vue?vue&type=style&index=0&id=ba7f0628&prod&scoped=true&lang=css&"
import style1 from "./WarrantyConfigList.vue?vue&type=style&index=1&id=ba7f0628&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7f0628",
  null
  
)

export default component.exports